import { render, staticRenderFns } from "./groupDinnerTemplateManage.vue?vue&type=template&id=17ab5552&scoped=true"
import script from "./groupDinnerTemplateManage.vue?vue&type=script&lang=js"
export * from "./groupDinnerTemplateManage.vue?vue&type=script&lang=js"
import style0 from "./groupDinnerTemplateManage.vue?vue&type=style&index=0&id=17ab5552&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ab5552",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17ab5552')) {
      api.createRecord('17ab5552', component.options)
    } else {
      api.reload('17ab5552', component.options)
    }
    module.hot.accept("./groupDinnerTemplateManage.vue?vue&type=template&id=17ab5552&scoped=true", function () {
      api.rerender('17ab5552', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/menuTemplateManage/groupDinnerTemplateManage.vue"
export default component.exports